import React from 'react';
import { IconButton as IconButtonMaterialUI } from '@mui/material';
import {
    Close,
    MoreVert,
    Visibility,
    VisibilityOff,
    AccountCircleRounded,
    ManageAccountsOutlined,
    PaymentOutlined,
    SettingsOutlined,
    LogoutOutlined,
    Replay,
    AlternateEmailOutlined,
    PhoneAndroidOutlined,
    LocationOnOutlined,
    BusinessOutlined,
    BadgeOutlined,
    PublicOutlined,
    ChevronLeft,
    CreditCardOffOutlined,
    VerifiedUserOutlined,
    LockOutlined,
    FilterAltOff,
    FilterAlt,
    Search,
    SearchOff,
    LanguageOutlined,
    AccessTimeOutlined,
    ModeEdit,
    FiberManualRecord,
    SortOutlined,
    SouthOutlined,
    NorthOutlined,
    Circle,
    InfoOutlined,
    MoneyOff,
    Speed,
    NewReleases,
    SupportAgent,
    TrendingUp,
    SimCardDownload,
    UploadFile,
    ToggleOn,
    ToggleOff,
    Category,
    Groups,
    Hotel,
    Payment,
    Add,
    Edit,
    Delete,
    ContentCopy,
    Info,
    DateRange,
    Face,
    ChildCare,
    ChildFriendly,
    Girl,
    Face3,
    Preview,
    Error,
    ReportProblem,
    NotInterested,
    Message,
    Email,
    Person,
    Event,
    Apartment,
    StickyNote2,
    Battery6Bar,
    Battery4Bar,
    Battery1Bar,
    Today,
    ContentPaste,
    Assignment,
    EditCalendar,
    Newspaper,
    EventNote,
    Bed,
    GppBad,
    Payments,
    Paid,
    Restaurant,
    Star,
    StarHalf,
    StarOutline,
    Description,
    DryCleaning,
    Battery0Bar,
    Tune,
    GridView,
    TableChart,
    InsertChartOutlined,
    ListAlt,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    FindReplace,
    KeyboardArrowUp,
    KeyboardArrowDown,
    ExpandLess,
    ExpandMore,
    Fullscreen,
    FullscreenExit,
    DeleteOutlined,
    ArrowBack,
    ChevronRight,
    LightModeOutlined,
    ModeNightOutlined,
    Pause,
    PlayArrowOutlined,
    Clear,
    VisibilityOutlined,
    FileDownloadOutlined,
    TrackChanges,
    NotificationsNoneOutlined,
} from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Excel from '../images/excel.svg';

/**
 * @typedef {import('@mui/material/IconButton').IconButtonProps & {
 *   iconName: string,
 *   iconProps?: import('@mui/material/SvgIcon').SvgIconProps,
 *   shape?: string,
 *   fontSize?: import('@mui/material/SvgIcon').SvgIconProps['fontSize']
 * }} IconButtonProps
 */

/** @type {React.ForwardRefRenderFunction<HTMLButtonElement, IconButtonProps>} */
const renderIconButton = (props, ref) => {
    const { iconName, iconProps = {}, ...restProps } = props;
    const icons = {
        Close,
        Visibility,
        VisibilityOff,
        InfoOutlinedIcon,
        MoreVert,

        AccountCircleRounded,
        ManageAccountsOutlined,
        PaymentOutlined,
        SettingsOutlined,
        LogoutOutlined,
        Replay,
        AlternateEmailOutlined,
        PhoneAndroidOutlined,
        LocationOnOutlined,
        BusinessOutlined,
        BadgeOutlined,
        PublicOutlined,
        ChevronLeft,
        CreditCardOffOutlined,
        VerifiedUserOutlined,
        LockOutlined,
        FilterAltOff,
        FilterAlt,
        Search,
        SearchOff,
        LanguageOutlined,
        AccessTimeOutlined,
        ModeEdit,
        FiberManualRecord,
        SortOutlined,
        SouthOutlined,
        NorthOutlined,
        Circle,
        InfoOutlined,
        MoneyOff,
        Speed,
        NewReleases,
        SupportAgent,
        TrendingUp,
        SimCardDownload,
        UploadFile,
        ToggleOn,
        ToggleOff,

        Category,
        Groups,
        Hotel,
        Payment,
        Add,
        Edit,
        Delete,
        ContentCopy,
        Info,
        DateRange,
        Face,
        ChildCare,
        ChildFriendly,
        Girl,
        Face3,
        Preview,
        Error,
        ReportProblem,
        NotInterested,
        Message,
        Email,
        Person,
        Event,
        Apartment,
        StickyNote2,
        Battery0Bar,
        Battery6Bar,
        Battery4Bar,
        Battery1Bar,
        Today,
        ContentPaste,
        Assignment,
        EditCalendar,
        Newspaper,
        EventNote,
        Bed,
        GppBad,
        Payments,
        Paid,
        Restaurant,
        Star,
        StarHalf,
        StarOutline,
        Description,
        DryCleaning,
        Tune,
        GridView,
        TableChart,
        InsertChartOutlined,
        ListAlt,
        KeyboardArrowLeft,
        KeyboardArrowRight,
        FindReplace,
        KeyboardArrowUp,
        KeyboardArrowDown,
        ExpandLess,
        ExpandMore,
        Fullscreen,
        FullscreenExit,
        DeleteOutlined,
        Excel,
        ArrowBack,
        ChevronRight,
        LightModeOutlined,
        ModeNightOutlined,
        Pause,
        PlayArrowOutlined,
        Clear,
        VisibilityOutlined,
        FileDownloadOutlined,
        TrackChanges,
        NotificationsNoneOutlined,
    };
    const Icon = icons[iconName];

    return (
        <IconButtonMaterialUI {...restProps} ref={ref}>
            <Icon {...iconProps} />
        </IconButtonMaterialUI>
    );
};

const IconButton = React.forwardRef(renderIconButton);
IconButton.displayName = 'IconButton';

export default IconButton;
